// extracted by mini-css-extract-plugin
export var chevronIcon = "_8t-2";
export var teamName = "_8t-1";
export var teamSwitcherButton = "_8t-0";